(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/common/assets/javascripts/constants/racing.js') >= 0) return;  svs.modules.push('/components/payment/common/assets/javascripts/constants/racing.js');
'use strict';

const Racing = {
  REPLACEMENT: 'REPLACEMENT'
};
setGlobal('svs.components.payment.common.constants.Racing', Racing);

 })(window);